import { styled } from '@shared/components';

const BaseControlButton = styled('button')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 26,
  height: 26,
  cursor: 'pointer',
  border: `1px solid ${theme.palette.grey['300']}`,
  borderRadius: theme.shape.rounded(1),
  backgroundColor: theme.palette.background.paper,
  '&[data-active="true"]': {
    backgroundColor: theme.palette.primary.lighter,
    color: theme.palette.primary.main,
  },
  '&[data-disabled="true"]': {
    cursor: 'not-allowed',
    opacity: 0.5,
  },
}));

type ControlButtonProps = Omit<React.ComponentPropsWithoutRef<'button'>, 'type'>;

export default function ControlButton(props: Readonly<ControlButtonProps>) {
  return <BaseControlButton {...props} type='button' />;
}
